import { Helmet } from "react-helmet-async";

const Maintenance = () => {
  return (
    <>
      <Helmet>
        <title>Gaonova — A new version is on the loom</title>
        <meta
          name="description"
          content="Gaonova is being lovingly rewoven. Our new version arrives very soon. Thank you for your patience."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <main className="min-h-screen relative overflow-hidden bg-gradient-to-b from-cream via-background to-background flex items-center justify-center px-6">
        {/* Ambient warmth */}
        <div className="absolute -top-20 -left-10 w-72 h-72 bg-terracotta/15 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-golden/15 rounded-full blur-3xl pointer-events-none" />

        {/* Faint Warli horizon */}
        <svg
          aria-hidden="true"
          className="absolute bottom-0 left-0 w-full h-16 text-earth/[0.08] pointer-events-none"
          viewBox="0 0 400 60"
          preserveAspectRatio="none"
          fill="currentColor"
        >
          <path d="M0 40 Q60 20 120 38 T240 35 T400 40 L400 60 L0 60 Z" />
        </svg>

        <div className="relative z-10 max-w-xl text-center">
          <p className="text-[11px] uppercase tracking-[0.32em] text-muted-foreground mb-6">
            Gaonova · Handcrafted in Rural India
          </p>

          <div className="mx-auto mb-8 w-16 h-16 rounded-full border border-border/60 flex items-center justify-center">
            {/* Mandala mark */}
            <svg viewBox="0 0 64 64" className="w-10 h-10 text-foreground/70" fill="none" stroke="currentColor" strokeWidth="1.2">
              <circle cx="32" cy="32" r="22" />
              <circle cx="32" cy="32" r="14" />
              <circle cx="32" cy="32" r="6" />
              {Array.from({ length: 12 }).map((_, i) => (
                <line
                  key={i}
                  x1="32"
                  y1="6"
                  x2="32"
                  y2="14"
                  transform={`rotate(${i * 30} 32 32)`}
                />
              ))}
            </svg>
          </div>

          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-foreground leading-tight tracking-tight mb-5">
            A new version is on the loom.
          </h1>

          <p className="text-muted-foreground text-base sm:text-lg leading-relaxed mb-8">
            We're carefully reweaving Gaonova so every village story lands the
            way it deserves. Our refreshed home arrives very soon — thank you
            for your patience.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center text-sm">
            <a
              href="mailto:hello@gaonova.com"
              className="px-5 py-2.5 rounded-md border border-border/70 text-foreground hover:bg-foreground/5 transition-colors"
            >
              hello@gaonova.com
            </a>
            <a
              href="https://www.instagram.com/gaonova"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 rounded-md border border-border/70 text-foreground hover:bg-foreground/5 transition-colors"
            >
              Follow the journey
            </a>
          </div>

          <p className="mt-10 text-[10px] uppercase tracking-[0.28em] text-muted-foreground">
            © {new Date().getFullYear()} Gaonova · Sayak Naskar & Arnab Roy
          </p>
        </div>
      </main>
    </>
  );
};

export default Maintenance;
